import React, { useEffect, useState } from "react";
import { VERBINDING_EVENT } from "../../http";
import styles from "./OfflineBanner.module.css";

/**
 * Melding bovenin het scherm zolang er geen verbinding is. Luistert naar de
 * browser (`online`/`offline`) én naar het seintje uit `http.tsx` wanneer een
 * verzoek de server niet bereikt. Niet wegklikbaar: verdwijnt vanzelf zodra
 * de verbinding terug is.
 */
const OfflineBanner: React.FC = () => {
  const [offline, setOffline] = useState(() => !navigator.onLine);

  useEffect(() => {
    const naarOffline = () => setOffline(true);
    const naarOnline = () => setOffline(false);
    const opSeintje = (event: Event) =>
      setOffline(!(event as CustomEvent<{ online: boolean }>).detail.online);

    window.addEventListener("offline", naarOffline);
    window.addEventListener("online", naarOnline);
    window.addEventListener(VERBINDING_EVENT, opSeintje);
    return () => {
      window.removeEventListener("offline", naarOffline);
      window.removeEventListener("online", naarOnline);
      window.removeEventListener(VERBINDING_EVENT, opSeintje);
    };
  }, []);

  if (!offline) return null;

  return (
    <div className={styles.banner} role="status" aria-live="polite">
      <span className={styles.icoon} aria-hidden="true">
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M2 8.8a15 15 0 0 1 20 0" />
          <path d="M5 12.5a10 10 0 0 1 14 0" />
          <path d="M8.5 16a5 5 0 0 1 7 0" />
          <line x1="12" y1="20" x2="12.01" y2="20" />
          <line x1="3" y1="3" x2="21" y2="21" />
        </svg>
      </span>
      <span className={styles.tekst}>
        <strong>Geen internetverbinding</strong>
        <span>
          Wat je nu opslaat, komt niet aan. Deze melding verdwijnt zodra de
          verbinding terug is.
        </span>
      </span>
    </div>
  );
};

export default OfflineBanner;
